import type {IAsset} from '@netx/core-asset-next/schema';
import {canManageAssetConstituentClips} from './canManageAssetConstituentClips';

export const canEditConstituentClip = (asset?: IAsset): boolean => {
	return canManageAssetConstituentClips(asset);
};
